import { Check, Warning } from "neetoicons";
import { Tag } from "neetoui";
import { useTranslation } from "react-i18next";

const Status = ({ isExpired }) => {
  const { t } = useTranslation();

  const tagProps = isExpired
    ? {
        icon: Warning,
        label: t("neetoMolecules.integrationCard.tags.expired"),
        style: "warning",
      }
    : {
        icon: Check,
        label: t("neetoMolecules.integrationCard.tags.connected"),
        style: "success",
      };

  return (
    <Tag
      className="flex-row-reverse"
      {...tagProps}
      data-testid="integration-status"
    />
  );
};

export default Status;
